export type TagColor =
  | "magenta"
  | "red"
  | "volcano"
  | "orange"
  | "gold"
  | "lime"
  | "green"
  | "cyan"
  | "blue"
  | "geekblue"
  | "purple";

export const colors: TagColor[] = [
  "magenta",
  "red",
  "volcano",
  "orange",
  "gold",
  "lime",
  "green",
  "cyan",
  "blue",
  "geekblue",
  "purple",
];
export const getHashColor = (str: string): TagColor => {
  let buf = Buffer.from(str);
  let res = buf.reduce((total, current) => {
    return total + current;
  });
  return colors[res % colors.length];
};